import { render, staticRenderFns } from "./micoapp_category.vue?vue&type=template&id=ba98789c&scoped=true"
import script from "./micoapp_category.vue?vue&type=script&lang=js"
export * from "./micoapp_category.vue?vue&type=script&lang=js"
import style0 from "./micoapp_category.vue?vue&type=style&index=0&id=ba98789c&prod&scoped=true&lang=css"
import style1 from "./micoapp_category.vue?vue&type=style&index=1&id=ba98789c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba98789c",
  null
  
)

export default component.exports